<div class="flex flex-col gap-2">
  @for (user of users; track user) {
    <div
      class="flex gap-3 items-center">
      <div class="relative w-16 h-16">
        @if (user.avatar) {
          <img [alt]="user.userId" [src]="user.avatar" class="rounded-full w-16 h-16"/>
        }
        @if (hasOnline(user)) {
          <svg viewBox="0 0 8 8" xmlns="http://www.w3.org/2000/svg" style="width: 10px; height: 10px;"
               class="absolute bottom-[-4px] right-[-4px] border-2 border-white">
            <circle cx="4" cy="4" r="4" [ngClass]="[user['online'] ? 'fill-green-500' : 'fill-red-500']"/>
          </svg>
        }
      </div>
      <span>
        {{ user.name || user.userId }}
      </span>
      @if (user.userId !== currentUserId) {
        <mat-icon (click)="sendMessageToUser.emit(user.userId)"
                  [title]="'personal_content.coop.write_message' | transloco"
                  class="text-primary cursor-pointer">mail
        </mat-icon>
      }
    </div>
  }
</div>
